<template v-if="globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker'">
	<section id="prosthesis_print">
		<div class="content printCont">
			<div class="contIn">
				<div class="popup_printBtn">
					<button class="printBtn" @click="commonjs.winPrint()">출력</button>
				</div>
				<div class="printDate">출력일 : {{ today }}</div>
				<div class="boardTit printTit">보철물 정보</div>
				<div class="printSub">{{ hos_member?.mb_nick || '[기본]' }} </div>
				<table>
					<tbody id="prosthodontics_list">
						<tr>
							<th class="cols1">번호</th>
							<th class="cols2">분류</th>
							<th class="cols3">상세</th>
							<th class="cols4">단가</th>
						</tr>
						<tr v-if="items.length > 0" v-for="(item, index) in items" :key="index">
							<td class="cols1">{{ index + 1 }}</td>
							<td class="cols2">{{ item.options }}</td>
							<td class="cols3">{{ item.detail }}</td>
							<td class="cols4">{{ item.price.toLocaleString() }}</td>
						</tr>
						<tr v-else>
							<td colspan="4">데이터가 없습니다.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</section>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

if(globaljs.acc_type === 'hospital' || globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

const today = moment().format('YYYY-MM-DD');

const hos_id = ref(route.query.hos_id);
watch(
	() => route.query.hos_id,
	(newVal) => {
		hos_id.value = newVal;
	}
);

const items = ref([]);
const hos_member = ref([]);

onMounted(async () => {
	if(globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker') {
		await getModels();
	}
});

const getModels = async () => {
	let url = `${SERVER_URL}/api/app/prosthesis`;
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('lab_id', globaljs.mb_boss_id);
	params.append('hide', 0);

	if (typeof route.query.hos_id !== 'undefined') {
		params.append('hos_id', route.query.hos_id);
		url = url + '/sub';
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(url, { params });
console.debug(response.data.result);
		if (response.data.result?.data) {
			items.value = response.data.result.data;
			hos_member.value = response.data.result?.hos_member;
		} else {
			items.value = response.data?.result;
		}
	} catch (error) {
console.error('Error getModels:', error);
	}
}
</script>